export function safeString(value) {
  return (typeof value === 'string' ? value : '').trim();
}

/** Collapse a message to a single line for the history rail. */
export function toPreview(value, maxLength = 120) {
  const text = safeString(value).replace(/\s+/g, ' ');
  return text.length > maxLength ? `${text.slice(0, maxLength).trimEnd()}…` : text;
}
